import React from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { LOGO_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/5">
      <div className="marquee-strip py-3 overflow-hidden" data-testid="research-marquee">
        <Marquee speed={40} gradient={false}>
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="label-mono text-cyan-400/80 mx-12">
              RESEARCH USE ONLY — NOT FOR HUMAN CONSUMPTION — STORE AT −20°C — PURITY ≥99% HPLC VERIFIED
            </span>
          ))}
        </Marquee>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center">
            <img src="/logo-transparent.png" alt="Novagenix Labs" className="h-16 w-auto object-contain" />
          </div>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed">
            High-purity research peptides synthesized under cGMP-aligned protocols. Independently HPLC-verified.
          </p>
        </div>

        <div>
          <div className="label-mono text-slate-400 mb-4">Catalog</div>
          <ul className="space-y-2.5 text-sm text-slate-300">
            <li><Link to="/shop" className="hover:text-cyan-400">All Peptides</Link></li>
            <li><Link to="/shop?category=Healing%20%26%20Recovery" className="hover:text-cyan-400">Healing & Recovery</Link></li>
            <li><Link to="/shop?category=Metabolic" className="hover:text-cyan-400">Metabolic</Link></li>
            <li><Link to="/shop?category=Growth%20Hormone" className="hover:text-cyan-400">Growth Hormone</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-mono text-slate-400 mb-4">Company</div>
          <ul className="space-y-2.5 text-sm text-slate-300">
            <li><Link to="/about" className="hover:text-cyan-400">About</Link></li>
            <li><Link to="/qr" className="hover:text-cyan-400">QR Access</Link></li>
            <li><a href="mailto:research@novagenix.com" className="hover:text-cyan-400">research@novagenix.com</a></li>
          </ul>
        </div>

        <div>
          <div className="label-mono text-slate-400 mb-4">Legal</div>
          <p className="text-xs text-slate-500 leading-relaxed">
            Products sold by Novagenix Labs are intended solely for in-vitro laboratory research.
            They are not approved for human or veterinary use, diagnosis, treatment, or cure of any condition.
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Novagenix Labs. All rights reserved.</div>
          <div className="font-mono tracking-widest">BATCH//NGX-{new Date().getFullYear()}-Q1</div>
        </div>
      </div>
    </footer>
  );
}
